import React, { Fragment, useState, useEffect, useMemo } from "react";
import AdminWrapper from "../AdminWrapper";
import SwitchMenuBar from "../../../Components/SwitchMenuBar/SwitchMenuBar";
import { API } from "../../../API";
import { notify } from "react-notify-toast";
import { cancellationReasons } from "../../Bookings2/Helper";
import FormDropdown from "../../../Components/FormField/FormDropdown";
import FormDatePicker from "../../../Components/FormField/FormDatePicker";
import DatePicker from "react-datepicker"
import CheckableButton from "../../../Components/CheckableButton/CheckableButton";
import { teacherResponse, teacherStatus, getClass } from "../../../Helper";
import ReactTable from "react-table-6";
import Moment from "react-moment";
import "moment-timezone";
import moment from "moment/moment";
import debounce from 'lodash/debounce';
import Pagination from '@mui/material/Pagination';
import { connect } from "react-redux";
const classListFull = getClass(true);

const BuildFilterBooking = (props) => {
	const { initialFilter, submitFilter } = props
	const [filterOption, setFilterOption] = useState(initialFilter)
	const [sortingOption, setSortingOption] = useState({
		sort_type: '-1',
		sort_by: 'status'
	})

	const onChangeValue = debounce((key, value) => {
		const newValue = {
			...filterOption,
			[key]: value
		}
		setFilterOption(newValue)
	}, 0);

	const onChangeSort = debounce((key, value) => {
		const newValue = {
			...sortingOption,
			[key]: value
		}
		setSortingOption(newValue)
	}, 0);

	return (
		<div id="accordion">
			<div class="card w-100">
				<div class="card-header border-none" id="headingOne">
					<h5 class="mb-0 d-flex justify-content-between">
						<button class="" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
							Explore Filter Booking
						</button>

						<button class="btn btn-info" onClick={() => submitFilter(filterOption, sortingOption)} disabled={props.disabled}>
							Apply
						</button>
					</h5>
				</div>

				<div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
					<div class="card-body">
						<div className="d-flex flex-column">
							<div className="d-flex flex-row">
								{/* <div className="mx-2">
									<p>Created Date</p>
									<DatePicker 
										isClearable
										dateFormat="dd/MM/yyyy" 
										selected={filterOption?.createdDate ? new Date(filterOption.createdDate) : null} 
										onChange={(date) => onChangeValue("createdDate", date)} 
										className="datepicker-2 my-2 form-control no-shadow"
										placeholderText="Select date"
									/>
								</div> */}
								{/* <div className="mx-2">
									<p>Start Date</p>
									<DatePicker 
										isClearable
										dateFormat="dd/MM/yyyy" 
										selected={filterOption?.startDate ? new Date(filterOption.startDate) : null} 
										onChange={(date) => onChangeValue("startDate", date)} 
										className="datepicker-2 my-2 form-control no-shadow"
										placeholderText="Select date"
									/>
								</div>
								<div className="mx-2">
									<p>End Date</p>
									<DatePicker 
										isClearable
										dateFormat="dd/MM/yyyy" 
										selected={filterOption?.endDate ? new Date(filterOption.endDate) : null} 
										onChange={(date) => onChangeValue("endDate", date)} 
										className="datepicker-2 my-2 form-control no-shadow"
										placeholderText="Select date"
									/>
								</div> */}
								{/* <div className="mx-2">
									<p>Arrival Time</p>
									<input
										onChange={event => onChangeValue("arrivalTime", event.target.value)}
										value={filterOption?.arrivalTime ? filterOption?.arrivalTime : ''}
										className="my-2 form-control no-shadow"
									/>
								</div>
								<div className="mx-2">
									<p>Start Time</p>
									<input
										onChange={event => onChangeValue("startTime", event.target.value)}
										value={filterOption?.startTime ? filterOption?.startTime : ''}
										className="my-2 form-control no-shadow"
									/>
								</div>
								<div className="mx-2">
									<p>End Time</p>
									<input
										onChange={event => onChangeValue("endTime", event.target.value)}
										value={filterOption?.endTime ? filterOption?.endTime : ''}
										className="my-2 form-control no-shadow"
									/>
								</div>
								<div className="mx-2">
									<p>Days</p>
									<input
										onChange={event => onChangeValue("days", event.target.value)}
										value={filterOption?.days ? filterOption?.days : ''}
										className="my-2 form-control no-shadow"
									/>
								</div>
								<div className="mx-2">
									<p>Level/Type</p>
									<input
										onChange={event => onChangeValue("levelType", event.target.value)}
										value={filterOption?.levelType ? filterOption?.levelType : ''}
										className="my-2 form-control no-shadow"
									/>
								</div>
								<div className="mx-2">
									<p>Mode</p>
									<select
										className="form-control no-shadow px-2 my-2"
										onChange={event => onChangeValue("mode", event.target.value)}
									>
										<option value="all">---</option>
										<option value="0">On Campus</option>
										<option value="1">Online</option>
									</select>
								</div> */}
							</div>
							<div className="d-flex flex-row">
								<div className="mx-2">
									<p>Start Date</p>
									<DatePicker
										isClearable
										dateFormat="dd/MM/yyyy"
										selected={filterOption?.startDate ? new Date(filterOption.startDate) : null}
										onChange={(date) => onChangeValue("startDate", date)}
										className="datepicker-2 my-2 form-control no-shadow"
										placeholderText="Select date"
									/>
								</div>
								<div className="mx-2">
									<p>End Date</p>
									<DatePicker
										isClearable
										dateFormat="dd/MM/yyyy"
										selected={filterOption?.endDate ? new Date(filterOption.endDate) : null}
										onChange={(date) => onChangeValue("endDate", date)}
										className="datepicker-2 my-2 form-control no-shadow"
										placeholderText="Select date"
									/>
								</div>
								<div className="mx-2" style={{'maxWidth': '150px'}}>
									<p>Institution</p>
									{/* <input
										onChange={event => onChangeValue("inst", event.target.value)}
										value={filterOption?.inst ? filterOption?.inst : ''}
										className="my-2 form-control no-shadow"
									/> */}
									<select
										className="form-control no-shadow px-2 my-2"
										onChange={event => onChangeValue("inst", event.target.value)}
									>
										<option value="all">---</option>
										{props.institutions.map(institution => <option value={institution._id}>{institution.institution_name}</option>)}
									</select>
								</div>
								<div className="mx-2" style={{'maxWidth': '150px'}}>
									<p>Campus</p>
									{/* <input
										onChange={event => onChangeValue("campus", event.target.value)}
										value={filterOption?.campus ? filterOption?.campus : ''}
										className="my-2 form-control no-shadow"
									/> */}
									<select
										className="form-control no-shadow px-2 my-2"
										onChange={event => onChangeValue("campus", event.target.value)}
									>
										<option value="all">---</option>
										{props.campuses.map(campus => {
											if(campus.campus_shortname && (
												!filterOption['inst'] || 
												filterOption['inst'] === 'all' ||
												(filterOption['inst'] && campus.institution_id === filterOption['inst']) 
												)
											) {
												return (
													<option value={campus._id}>
														{campus.campus_shortname} - {campus.suburb || ''}
													</option>
												)
											}
										})}
									</select>
								</div>
								<div className="mx-2">
									<p>Maker</p>
									{/* <input
										onChange={event => onChangeValue("maker", event.target.value)}
										value={filterOption?.maker ? filterOption?.maker : ''}
										className="my-2 form-control no-shadow"
									/> */}
									<select
										className="form-control no-shadow px-2 my-2"
										onChange={event => onChangeValue("maker", event.target.value)}
									>
										<option value="all">---</option>
										{props.customers.map(customer => {
											// console.log(customer.institution)
											if(customer.first_name && customer.last_name && (
												!filterOption['inst'] || 
												filterOption['inst'] === 'all' ||
												(filterOption['inst'] && customer.institution_id === filterOption['inst']) 
											)) {
												// console.log("matched")
												return (
													<option value={customer._id}>
														{`${customer.first_name} ${customer.preferred_name || ""} ${customer.last_name}`}
													</option>
												)
											}
										})}
									</select>
								</div>
								<div className="mx-2" style={{'maxWidth': '150px'}}>
									<p>Level</p>
									<select
										className="form-control no-shadow px-2 my-2"
										onChange={event => onChangeValue("level", event.target.value)}
									>
										<option value="all">---</option>
										{
											classListFull.filter(cl => cl.type.includes("ge") && cl.key !== "All ELICOS")
											.map(cl => <option value={cl.key}>{cl.whole_name}</option>)
										}
									</select>
								</div>
								{/* <div className="mx-2">
									<p>Teaching Hours</p>
									<input
										onChange={event => onChangeValue("totalTeachingHours", event.target.value)}
										value={filterOption?.totalTeachingHours ? filterOption?.totalTeachingHours : ''}
										className="my-2 form-control no-shadow"
									/>
								</div>
								<div className="mx-2">
									<p>Preferred Teacher</p>
									<input
										onChange={event => onChangeValue("preferredTeacher", event.target.value)}
										value={filterOption?.preferredTeacher ? filterOption?.preferredTeacher : ''}
										className="my-2 form-control no-shadow"
									/>
								</div>
								<div className="mx-2">
									<p>No. of Events</p>
									<input
										onChange={event => onChangeValue("numberOfEvents", event.target.value)}
										value={filterOption?.numberOfEvents ? filterOption?.numberOfEvents : ''}
										className="my-2 form-control no-shadow"
									/>
								</div> */}
								<div className="mx-2" style={{'maxWidth': '150px'}}>
									<p>Allocation</p>
									<select
										className="form-control no-shadow px-2 my-2"
										onChange={event => onChangeValue("allocation", event.target.value)}
									>
										<option value="all">---</option>
										{props.teachers.map(teacher => 
										<option value={teacher._id}>
											{`${teacher.first_name} ${teacher.preferred_name || ""} ${teacher.last_name}`}
										</option>)}
									</select>
								</div>
								<div className="mx-2" style={{'maxWidth': '150px'}}>
									<p>Preferred Teacher</p>
									<select
										className="form-control no-shadow px-2 my-2"
										onChange={event => onChangeValue("preferredTeacher", event.target.value)}
									>
										<option value="all">---</option>
										{props.teachers.map(teacher => 
										<option value={teacher._id}>
											{`${teacher.first_name} ${teacher.preferred_name || ""} ${teacher.last_name}`}
										</option>)}
									</select>
								</div>
								<div className="mx-2">
									<p>Status</p>
									<select
										className="form-control no-shadow px-2 my-2"
										onChange={event => onChangeValue("status", event.target.value)}
									>
										<option value="all">---</option>
										<option value={teacherStatus.not_assigned}>{teacherStatus.not_assigned}</option>
										<option value={teacherStatus.assigned}>{teacherStatus.assigned}</option>
										<option value={teacherStatus.none_available}>{teacherStatus.none_available}</option>
										<option value={teacherResponse.accepted} >{teacherResponse.accepted}</option>
										<option value={teacherResponse.rejected}>{teacherResponse.rejected}</option>
										<option value={teacherResponse.cancelled}>{teacherResponse.cancelled}</option>
										<option value="requested_day_off">{teacherResponse.rdo}</option>
										<option value="cancelled_by_inst">cancelled by inst</option>
									</select>
								</div>
								{/* <div className="mx-2">
									<p>Cancel Reason</p>
									<select
										className="form-control no-shadow px-2 my-2"
										onChange={event => onChangeValue("cancelReason", event.target.value)}
									>
										<option value="all">---</option>
										{cancellationReasons.map((reason) => {
											return (
												<option value={reason.value}>
													{reason.description}
												</option>
											);
										})}
									</select>
								</div> */}
								<div className="mx-2">
									<p>Booking Type</p>
									<select
										className="form-control no-shadow px-2 my-2"
										onChange={event => onChangeValue("bookingType", event.target.value)}
									>
										<option value="all">---</option>
										<option value="urgent-reallocate">Urgent Reallocation</option>
									</select>
								</div>
							</div>
							<div className="d-flex flex-row my-2">
								<div className="mx-2" style={{'maxWidth': '150px'}}>
									<p>Sort By</p>
									<select
										className="form-control no-shadow px-2 my-2"
										onChange={event => onChangeSort("sort_by", event.target.value)}
									>
										<option value="status" selected>---</option>
										<option value="created_at">Created Time</option>
										<option value="start_date">Start Date</option>
									</select>
								</div>
								<div className="mx-2" style={{'maxWidth': '150px'}}>
									<p>Sort Type</p>
									<select
										className="form-control no-shadow px-2 my-2"
										onChange={event => onChangeSort("sort_type", event.target.value)}
									>
										<option value="1">ASC</option>
										<option value="-1" selected>DESC</option>
									</select>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}


const AllocationTableNewPage = (props) => {
	let [isAllBookinngsLoaded, setAllBookinngsLoaded] = useState(false);
	let [allUsers, setAllUsers] = useState([]);
	let [allCampus, setAllCampus] = useState([]);
	let [allInst, setAllInst] = useState([]);
	let [allClass, setAllClass] = useState([]);
	let [allInstUsers, setAllInstUsers] = useState([]);
	let [data, setData] = useState([]);
	let [currentSplitEventByBooking, setCurrentSplitEventByBooking] = useState({})
	let [numberOfSplitEvent, setNumberOfSplitEvent] = useState(0)
	let [showCreatedTime, setShowCreatedTime] = useState(true);
	let [showCampus, setShowCampus] = useState(false);
	let [show25kms, setShow25kms] = useState(false);
	let [showFav, setShowFav] = useState(false);
	let [showAvail, setShowAvail] = useState(false);
	let [showArrival, setShowArrival] = useState(false);
	let [showTeachingHours, setShowTeachingHours] = useState(false);
	let [showNonTeachingHours, setShowNonTeachingHours] = useState(false);
	let [showLastTeacher, setShowLastTeacher] = useState(false);
	let [showUpdateLevel, setShowUpdateLevel] = useState(false);
	let [updatedLevel, setUpdatedLevel] = useState("");
	let [showTestBookings, setShowTestBookings] = useState(false);
	let [currentResplitBooking, setCurrentResplitBooking] = useState({})
	let [selectedInst, setSelectedInst] = useState(null)
	const [simpleQualificationList, setSimpleQualifications] = useState(props.simpleQualifications)

	let [paginate, setPaginate] = useState({
		limit: 20,
		total_page: 0,
		page: 1,
		total_record: 0
	})

	const bookingDict = {};
	const campusDict = {};
	let testBookingDatalist = []
	const classList = getClass();

	const getAllUsers = async () => {
		try {
			await API.allTeachersSearchableForAllocate()
				.then(function (result) {
					let users = result.data
						.filter((user) => {
							return user.first_name || user.last_name;
						})
						.sort((a, b) => {
							let nameA = (a.first_name + " " + a.last_name).toLowerCase();
							let nameB = (b.first_name + " " + b.last_name).toLowerCase();
							return nameA > nameB ? 1 : -1;
						});
					// console.log(users.map(user => user.first_name + " " + user.last_name))
					setAllUsers(users);
				})
				.catch(function (err) {
					console.log(err);
				});
		} catch (error) {
			alert(error);
		}
	};

	const getAllInstUsers = async () => {
		try {
			await API.allInstUsersForAllocate()
				.then((result) => {
					setAllInstUsers(result.data);		
				})
				.catch((err) => {
					console.log(err);
				});
		} catch (error) {
			alert(error);
		}
	};

	const getAllCampus = async () => {
		try {
			await API.getAllCampusWithCache()
				.then(function (result) {
					setAllCampus(result.data);
				})
				.catch(function (err) {
					console.log(err);
				});
		} catch (error) {
			alert(error);
		}
	};

	const getAllInst = async () => {
		try {
			await API.getAllInstWithCache()
				.then(function (result) {
					setAllInst(result.data);
				})
				.catch(function (err) {
					console.log(err);
				});
		} catch (error) {
			alert(error);
		}
	};

	const getAllClass = async () => {
		try {
			await API.getAllClasses()
				.then(function (result) {
					// console.log("allClass: ", result.data)
					setAllClass(result.data);
				})
				.catch(function (err) {
					console.log(err);
				});
		} catch (error) {
			alert(error);
		}
	};

	const getBookings = async () => {
		try {
			console.log("Loading booking...")
			const query = {
				page: paginate.page,
				limit: paginate.limit,
			}
			await API.getListBooking(query)
				.then(function (result) {
					setPaginate(result.data?.paginate)
					// setAllBookinngsLoaded(true);
					groupBookingsBasedOnId(result.data.bookings);
					convertBookings(result.data.bookings);
				})
				.catch(function (err) {
					console.log(err);
				});
		} catch (error) {
			alert(error);
		}
	};

	const convertBookings = (bookings) => {
		const datalist = [];
		// console.log("Bookings", bookings);
		if (bookings) {
			testBookingDatalist = []
			console.time("convertBooking")
			bookings.forEach((item) => {
				let campus = campusDict[item.campus_id] || null;
				if (campus === null) {
					campus = allCampus.find((el) => el._id === item.campus_id);
					campusDict[item.campus_id] = campus;
				}

				let inst = null;
				if (campus) {
					inst = allInst.find((el) => el._id === campus.institution_id);
				}

				let maker = item.booking_maker
					? allInstUsers.find((el) => el._id === item.booking_maker)
					: null;
				let makername = maker
					? maker.first_name
						? `${maker.first_name} ${maker.last_name.charAt(0)}` + "."
						: `${maker.personnel_first_name} ${maker.personnel_last_name.charAt(0)}` + "."
					: "";

				let preferred_teacher = item.preferred_teacher
					? allUsers.find((el) => el._id === item.preferred_teacher)
					: null;
				let pref_tea_name = preferred_teacher
					? `${preferred_teacher.first_name} ${preferred_teacher.last_name}`
					: "None";

				let institution = inst ? inst.institution_name : "Inst not found";
				let campus_city = campus ? campus.suburb : "Campus not found";
				let last_allocate = getLastBookingTeacherAllocation(
					item.campus_id,
					item.end_booking_date
				);
				last_allocate = last_allocate.map(item => {
					if (item) {
						const fullName = item.replace(/\s+/g, " ").split(" ");
						return fullName.shift() + " " + fullName.pop().charAt(0).toUpperCase() + "."
					}
					return item
				})

				last_allocate = last_allocate.join(", ")
				let level = item.level;
				let deliveryMode =
					item.online ?
						item.deliver_from_home === undefined ? "Online"
							:
							(item.deliver_from_home ? "Online - Deliver from home" : "Online - Deliver on-campus")
						:
						"On Campus"
				let start_date = item.booking_date;
				let start_date_array = start_date ? start_date.split("-") : [0, 0, 0];
				let start_date_au = `${start_date_array[2]}/${start_date_array[1]}/${start_date_array[0]}`;
				let end_date = item.end_booking_date;
				let end_date_array = end_date ? end_date.split("-") : [0, 0, 0];
				let end_date_au = `${end_date_array[2]}/${end_date_array[1]}/${end_date_array[0]}`;
				let split_start_date = start_date;
				let split_end_date =
					item.multiple_date && item.splits && item.splits.length > 0
						? item.splits[0].date_to
						: end_date;
				let days_of_delivery = item.days_of_delivery
					? item.days_of_delivery
					: "";
				let unavailable_teacher = item.unavailable_teacher ? item.unavailable_teacher : false;

				const startDate = new Date(start_date)
				const endDate = new Date(end_date);
				endDate.setDate(endDate.getDate() + 1);
				const daysOfWeekInRange = [];
				let i = 0;
				while (i < 7 && startDate < endDate) {
					daysOfWeekInRange.push(startDate.toLocaleString('en-us', { weekday: 'long' }));
					startDate.setDate(startDate.getDate() + 1);
					i++;
				}

				let lessons =
					item.dates && item.dates.length > 0 ? item.dates.length : 1;
				let arrival = item.arrival_time;
				let start = item.start_time;
				let end = item.end_time;
				let teaching_hour = item.paid_teaching_hours;
				let non_teaching_mins = item.paid_nonteaching_mins
					? item.non_teach_calculation === 'daily'
						? item.paid_nonteaching_mins + ' mins/day'
						: item.non_teach_calculation === 'weekly'
							? item.paid_nonteaching_mins + ' mins/week'
							: item.non_teach_calculation === 'monthly'
								? item.paid_nonteaching_mins + ' mins/month' : 0
					: 0
				let total_teaching_hour = teaching_hour * (item.multiple_date ? item.dates.length : 1);

				days_of_delivery = days_of_delivery.replace(/^,/, "").split(",").filter(value => daysOfWeekInRange.includes(value));
				let status = item.multiple_date
					? !item.splits || item.splits.length === 0
						? item.cancelled_by_inst
							? "cancelled by inst"
							: item.teacher_status
								? item.teacher_status === teacherStatus.responded
									? item.teacher_response
									: item.teacher_status
								: teacherStatus.not_assigned
						: item.splits[0].cancelled_by_inst
							? "cancelled by inst"
							: item.splits[0].teacher_status === teacherStatus.responded
								? item.splits[0].is_rdo ?  "requested day off" : item.splits[0].teacher_response
								: item.splits[0].teacher_status
					: item.cancelled_by_inst
						? "cancelled by inst"
						: item.teacher_status === teacherStatus.responded
							? item.teacher_response
							: item.unavailable_teacher ? teacherStatus.none_available : item.teacher_status;
				let teacher = item.multiple_date
					? !item.splits || item.splits.length === 0
						? item.teacher_id
							? allUsers.find((el) => {
								return el._id === item.teacher_id;
							})
							: null
						: item.splits[0].teacher_id
							? allUsers.find((el) => {
								return el._id === item.splits[0].teacher_id;
							})
							: null
					: item.teacher_id
						? allUsers.find((el) => {
							return el._id === item.teacher_id;
						})
						: null;
				let teachername = teacher
					? `${teacher.first_name} ${teacher.last_name}`
					: "";
				let fav_teacher_list = inst ? inst.fav_teacher_list : [];
				let teacher_status = item.multiple_date
					? !item.splits || item.splits.length === 0
						? item.teacher_status
							? item.teacher_status
							: teacherStatus.not_assigned
						: item.splits[0].teacher_status
					: item.teacher_status;
				let teacher_response = item.multiple_date
					? !item.splits || item.splits.length === 0
						? item.teacher_response
							? item.teacher_response
							: teacherResponse.not_responded
						: item.splits[0].teacher_response
					: item.teacher_response;
				let payment_status = item.multiple_date
					? !item.splits || item.splits.length === 0
						? item.payment_status
							? item.payment_status
							: ""
						: item.splits[0].payment_status
					: item.payment_status
						? item.payment_status
						: "";
				let teacher_cancel_reason = item.multiple_date
					? !item.splits || item.splits.length === 0
						? item.teacher_cancel_reason || ""
						: item.splits[0].teacher_cancel_reason || ""
					: item.teacher_cancel_reason || "";

				let previous_teacher_allocation = item.multiple_date
					? !item.splits || item.splits.length === 0
						? item.previous_teacher_allocation || ""
						: item.splits[0].previous_teacher_allocation || ""
					: item.previous_teacher_allocation || "";

				let canceledTime = item.multiple_date && item.splits.length
					? item.splits?.find(ele => ele.date_from === split_start_date && ele.date_to === split_end_date)?.cancelled_time
					: item?.cancelled_time

				let inst_cancel_reason = item.multiple_date && item.splits.length
					? item.splits?.find(ele => ele.date_from === split_start_date && ele.date_to === split_end_date)?.inst_cancelled_reason
					: item?.inst_cancelled_reason

				let canceledBy = item.multiple_date && item.splits.length
					? item.splits?.find(ele => ele.date_from === split_start_date && ele.date_to === split_end_date)?.cancelled_by
					: item?.cancelled_by

				let last_status_before_cancel = item.multiple_date && item.splits.length
					? item.splits?.find(ele => ele.date_from === split_start_date && ele.date_to === split_end_date)?.last_status_before_cancel
					: item?.last_status_before_cancel

				let selected_class = item.class

				// ================ Any extra fields here for the customized cells

				if (item.splits.length) {
					currentSplitEventByBooking = {
						...currentSplitEventByBooking,
						[item._id]: item.splits.length
					}
				}

				let classRef = "";
				if(allClass) {
					classRef = allClass.find((c) => c.class_id === item.class_id)?.reference_name || item?.class?.reference_name
				}

				let job = {
					id: item._id,
					campus_id: item.campus_id,
					class_id: item.class_id,
					multiple_date: item.multiple_date,
					all_dates: item.dates,
					dates: item.dates,
					splits: item.splits,
					institution,
					deliveryMode,
					makername,
					campus_city,
					last_allocate,
					level,
					start_date,
					start_date_au,
					end_date,
					end_date_au,
					split_start_date,
					split_end_date,
					days_of_delivery,
					lessons,
					arrival,
					start,
					end,
					teaching_hour,
					non_teaching_mins,
					total_teaching_hour,
					// non_teaching_hour,
					// total_hour,
					// whole_booking,
					status,
					teacher_status,
					teacher_response,
					payment_status,
					teachername,
					teacher,
					teachers: allUsers,
					fav_teacher_list,
					check_fav: false,
					check_ava: false,
					check_25km: false,
					split_index: 0,
					preferred_teacher,
					pref_tea_name,
					toConfirm: false,
					teacher_cancel_reason,
					inst_cancel_reason: inst_cancel_reason,
					created: item.createdAt,
					previous_teacher_allocation,
					unavailable_teacher,
					cancelled_by: canceledBy,
					cancelled_time: canceledTime,
					last_status_before_cancel: last_status_before_cancel,
					classRef: classRef,
					institution_id: maker?.institution_id,
					selected_class
				};
				datalist.push(job);

				if (item.splits && item.splits.length > 1) {
					for (let i = 1; i < item.splits.length; i++) {
						let subsplit_start_date = item.splits[i].date_from;
						let subsplit_end_date = item.splits[i].date_to;

						let substatus = item.splits[i].cancelled_by_inst
							? "cancelled by inst"
							: item.splits[i].teacher_status === teacherStatus.responded
								? item.splits[i].is_rdo ?  "requested day off" : item.splits[i].teacher_response
								: item.splits[i].teacher_status;

						let subteacher_status = item.splits[i].teacher_status;
						let subteacher_response = item.splits[i].teacher_response;
						let subpayment_status = item.splits[i].payment_status;

						let subteacher = item.splits[i].teacher_id
							? allUsers.find((el) => {
								return el._id === item.splits[i].teacher_id;
							})
							: null;

						let subteachername = subteacher
							? `${subteacher.first_name} ${subteacher.last_name}`
							: "";

						let subdates = item.dates.filter((date) => {
							return date.date > subsplit_start_date;
						});

						let subcancelreason = item.splits[i].teacher_cancel_reason || "";
						let subinstcancelreason = item.splits[i].inst_cancelled_reason || "";

						let sub_previous_teacher_allocation =
							item.splits[i].previous_teacher_allocation || "";

						let sub_unavailable_teacher = item.splits[i].unavailable_teacher || false

						let selected_class = item.class

						let subjob = {
							id: item._id,
							multiple_date: item.multiple_date,
							all_dates: item.dates,
							dates: subdates,
							splits: item.splits,
							split_start_date: subsplit_start_date,
							split_end_date: subsplit_end_date,
							status: substatus,
							teacher_status: subteacher_status,
							teacher_response: subteacher_response,
							payment_status: subpayment_status,
							teachername: subteachername,
							teacher: subteacher,
							teachers: allUsers,
							fav_teacher_list,
							check_fav: job.check_fav,
							check_ava: job.check_ava,
							check_25km: job.check_25km,
							split_index: i,
							preferred_teacher,
							pref_tea_name,
							toConfirm: false,
							is_subjob: true,
							created: job.created,
							institution: job.institution,
							makername: job.makername,
							campus_city: job.campus_city,
							deliveryMode: job.deliveryMode,
							last_allocate: job.last_allocate,
							level: job.level,
							start_date: job.start_date,
							end_date: job.end_date,
							days_of_delivery: job.days_of_delivery,
							lessons: job.lessons,
							arrival: job.arrival,
							start: job.start,
							end: job.end,
							teaching_hour: job.teaching_hour,
							non_teaching_mins: job.non_teaching_mins,
							total_teaching_hour: job.total_teaching_hour,
							teacher_cancel_reason: subcancelreason,
							inst_cancel_reason: subinstcancelreason,
							previous_teacher_allocation: sub_previous_teacher_allocation,
							unavailable_teacher: sub_unavailable_teacher,
							cancelled_by: item.splits[i].cancelled_by,
							cancelled_time: item.splits[i].cancelled_time,
							last_status_before_cancel: item.splits[i].last_status_before_cancel,
							institution_id: job?.institution_id,
							selected_class: selected_class
						};
						datalist.push(subjob);
						// if (subjob.makername === "ReadyTeacher T." || subjob.institution === "ReadyTeacherTest") {
						// 	testBookingDatalist.push(subjob);
						// } else {
						// 	datalist.push(subjob);
						// }
					}
				}
			});
			console.timeEnd("convertBooking")
		}
		// console.log("datalist: ", datalist, testBookingDatalist, showTestBookings)
		setData([
			...datalist
		]);
		setAllBookinngsLoaded(true);
	};

	const getLastBookingTeacherAllocation = (campus_id, end_booking_date) => {
		const assignedTeacherDict = {};
		const instId = queryInstitutionId(campus_id);

		const bookingList = bookingDict[instId] || null;
		if (bookingList) {
			let currentTime = new Date(end_booking_date).getTime();
			const lastBooking = bookingList.find((item) => {
				let comparedTime = new Date(item.end_booking_date).getTime();
				return comparedTime < currentTime;
			});

			if (lastBooking) {
				if (lastBooking.splits.length > 0) {
					lastBooking.splits.forEach((spl) => {
						if (spl.teacher_id && !assignedTeacherDict[spl.teacher_id]) {
							assignedTeacherDict[spl.teacher_id] = queryTeacherName(
								spl.teacher_id
							);
						}
					});
				} else {
					if (
						lastBooking.teacher_id &&
						!assignedTeacherDict[lastBooking.teacher_id]
					) {
						assignedTeacherDict[lastBooking.teacher_id] = queryTeacherName(
							lastBooking.teacher_id
						);
					}
				}
			}
		}

		return Object.values(assignedTeacherDict);
	};

	const getFullName = (key) => {
		if (key) {
			let object = classList.find((item) => {
				return item.key === key;
			});
			if (object) {
				return object.whole_name;
			} else {
				return "";
			}
		} else {
			return "";
		}
	};

	const getLevelName = (levelID) => {
		const levelItem = simpleQualificationList.find(ele => ele._id === levelID)
		return levelItem ? (levelItem?.code ? `${levelItem.title} (${levelItem.code})` : levelItem.title)
			: levelID
	};

	useEffect(() => {
		getAllUsers();
		getAllInstUsers();
		getAllInst();
		getAllCampus();
		getAllClass();

		// check simpleQualification list
		if(!simpleQualificationList?.length) {
			API.getSimpleQualification().then(res => {
			  setSimpleQualifications(res?.data?.data)
			})
		}
	}, []);

	useEffect(() => {
		if (
			allUsers.length > 0 &&
			allCampus.length > 0 &&
			allInst.length > 0 &&
			allInstUsers.length > 0
		) {
			getBookings();
		}
	}, [allCampus, allInst, allUsers, allInstUsers]);

	const groupBookingsBasedOnId = (allBookings) => {
		if (allBookings) {
			allBookings.forEach((item) => {
				let campus = campusDict[item.campus_id] || null;
				if (campus == null) {
					campus = allCampus.find((el) => el._id == item.campus_id);
					campusDict[item.campus_id] = campus;
				}

				if (campus != null) {
					let bookings = bookingDict[campus.institution_id] || null;
					if (bookings == null) {
						bookings = [];
						bookingDict[campus.institution_id] = bookings;
					}

					bookings.push(item);
				}
			});
		}
	};

	const buildSubEventObject = (
		id,
		rowIndex,
		split_index,
		data,
		start,
		end,
		dates
	) => {
		if (split_index != 0) {
			const subItem = {
				id: id,
				multiple_date: data[rowIndex].multiple_date,
				splits: data[rowIndex].splits,
				status: teacherStatus.not_assigned,
				teacher_status: teacherStatus.not_assigned,
				teacher_response: teacherResponse.not_responded,
				payment_status: "",
				teachername: "",
				teachers: data[rowIndex].teachers,
				fav_teacher_list: data[rowIndex].fav_teacher_list,
				check_fav: data[rowIndex].check_fav,
				check_ava: data[rowIndex].check_ava,
				check_25km: data[rowIndex].check_25km,
				split_index: split_index,
				preferred_teacher: data[rowIndex].preferred_teacher,
				pref_tea_name: data[rowIndex].pref_tea_name,
				split_start_date: start,
				split_end_date: end,
				dates,
				all_dates: data[rowIndex].all_dates,
				created: data[rowIndex].created,
				institution: data[rowIndex].institution,
				level: data[rowIndex].level,
				start: data[rowIndex].start,
				end: data[rowIndex].end,
				arrival: data[rowIndex].arrival,
				days_of_delivery: data[rowIndex].days_of_delivery,
				deliveryMode: data[rowIndex].deliveryMode,
				total_teaching_hour: data[rowIndex].total_teaching_hour,
				filter_last_allocate: data[rowIndex].last_allocate,
				filter_start_date_au: data[rowIndex].start_date_au,
				filter_end_date_au: data[rowIndex].end_date_au,
				filter_start_date: data[rowIndex].start_date,
				filter_end_date: data[rowIndex].end_date,
				filter_lessons: data[rowIndex].lessons,
				makername: data[rowIndex].makername
			}
			return subItem;
		} else {
			let item = data[rowIndex];
			item.status = teacherStatus.not_assigned;
			item.teacher_status = teacherStatus.not_assigned;
			item.teacher_response = teacherResponse.not_responded;
			item.payment_status = "";
			item.teachername = "";
			item.split_start_date = start;
			item.split_end_date = end;
			item.dates = dates;
			item.all_dates = dates

			return item;
		}
	};

	const queryInstitutionId = (campus_id) => {
		let result = null;
		const campus = allCampus.find((el) => el._id == campus_id);
		if (campus) {
			result = campus.institution_id;
		}

		return result;
	};

	const queryTeacherName = (teacher_id) => {
		const foundTeacher = allUsers.find((item) => item._id === teacher_id);
		return foundTeacher
			? foundTeacher.first_name + " " + foundTeacher.last_name
			: "";
	};

	const splitBookingValueChange = (id, rowIndex, event) => {
		const numberOfEvents = +event.target.value
		let all_dates = data[rowIndex].all_dates;
		// validate numberOfEvents here - not yet
		if (numberOfEvents > all_dates.length) {
			notify.show("Number of events can't be greater than total day of booking");
			event.target.value = 1
			return;
		}

		// handling

		if (rowIndex >= 0) {
			setNumberOfSplitEvent(numberOfEvents)
			let newData = [...data];
			// console.log("currentSplitEventByBooking: ", data[rowIndex].id, numberOfEvents, currentSplitEventByBooking)
			if (currentSplitEventByBooking[data[rowIndex].id]) {
				// console.log("Should remove first")
				newData.splice(rowIndex + 1, currentSplitEventByBooking[data[rowIndex].id] - 1);
			}

			setCurrentSplitEventByBooking({
				...currentSplitEventByBooking,
				[data[rowIndex].id]: +numberOfEvents
			})


			// console.log("currentSplitEventByBooking 2222: ", numberOfEvents, currentSplitEventByBooking)
			if (numberOfEvents === 0) {
				let start_date = all_dates[0]?.date
				let end_date = all_dates[all_dates?.length - 1]?.date
				let dates = all_dates.filter((_, index) => index > 1);
				newData.splice(
					rowIndex,
					1,
					buildSubEventObject(id, rowIndex, 0, data, start_date, end_date, all_dates)
				);
				newData.splice(rowIndex + 1, data[rowIndex].splits.length);
			}
			else {
				for (let i = 0; i < numberOfEvents; i++) {
					let start_date = all_dates[i].date
					let end_date = i === numberOfEvents - 1 ? all_dates[all_dates.length - 1].date : start_date
					let dates = i === 0 ? all_dates : all_dates.filter((_, index) => index > i);
					newData.splice(
						rowIndex + i,
						1 - i >= 0 ? 1 - i : 0,
						buildSubEventObject(id, rowIndex, i, data, start_date, end_date, dates)
					);
				}
			}
			setData(newData);
		}
	}

	const haveAtLeastOnEventAllocated = (props) => {
		const { id } = props.original;
		const foundBooking = data.find((el) => el.id === id);
		if (foundBooking) {
			if (foundBooking.multiple_date) {
				const events = data.filter((el) => el.id === id);
				if (events && events.length > 0) {
					let result = false;
					for (let i = 0; i < events.length && !result; i++) {
						if (
							events[i].teacher &&
							events[i].status != teacherStatus.not_assigned
						) {
							result = true;
						}
					}
					return result;
				} else {
					return foundBooking.status === teacherStatus.not_assigned
						? false
						: true;
				}
			} else {
				return foundBooking.status === teacherStatus.not_assigned
					? false
					: true;
			}
		}
	};

	const buildUpdateLevel = (props) => {
		const foundBooking = data.find((el) => el.id === props.original.id);
		// console.log("allClass: ", allClass)
		const levels = allClass.find((c) => c.class_id === foundBooking.class_id)?.selected_levels
		return <div>
			<FormDropdown onChange={(e) => setUpdatedLevel(e.target.value)}>
				<option value="">
					Select class level
				</option>
				{levels && levels.map((level) =>
					<option value={level}>
						{/* {getClass().find(c => c.key === level)?.whole_name} */}
						{getLevelName(level)}
					</option>)}
			</FormDropdown>

			<button
				className="btn btn-primary btn-sm"
				onClick={() => updateLevel(props, updatedLevel)}
			>
				Update
			</button>
		</div>
	}

	const updateLevel = (props, levelID) => {
		const levelName = getLevelName(levelID)
		if (levelID && levelName) {
			let newData = [...data];
			API.updateBookingLevel(props.original.id, levelName, levelID).then((result) => {
				// setUpdatedLevel(level)
				const foundBooking = newData.find((el) => el.id === props.original.id);
				if (foundBooking) {
					// console.log(foundBooking)
					foundBooking.level = levelName
					foundBooking.class_level_id = levelID 
					// getClass().find(c => c.key === level)?.whole_name
				}
				setData(newData);
				notify.show("Level updated successfully")
			}).catch((err) => {
				console.log(err);
			});
		} else {
			notify.show("Please select a valid level")
		}
	}

	const buildSplitCheckboxes = (props) => {
		const atLeastAllocated = haveAtLeastOnEventAllocated(props);
		const foundBooking = data.find((el) => el.id === props.original.id);
		const { original } = props;

		return props.original.split_index === 0 ? (
			<div
				style={
					atLeastAllocated || !foundBooking.multiple_date
						? { pointerEvents: "none" }
						: null
				}
			>
				{
					original.multiple_date &&
					original.all_dates &&
					original.all_dates.length &&
					(!atLeastAllocated || (currentResplitBooking[original.id]?.isEdit)) && (
						<React.Fragment>
							Split
							<input className="mx-2 px-2" type="number"
								defaultValue={!!currentSplitEventByBooking?.[original.id] ? currentSplitEventByBooking?.[original.id] : original.splits.length}
								name="split_to"
								min="1"
								max={original.all_dates.length}
								style={
									{ width: "30px", border: "1px solid black" }
								}
								onChange={(evt) =>
									splitBookingValueChange(
										props.original.id,
										props.index,
										evt
									)
								}
							/>
						</React.Fragment>
					)
				}
			</div>
		) : null;
	};

	const dropdownCell = ({ original }) => {
		const teachers = original.teachers;
		const allocated = hasAllocatedStatusForCurrentEvent(original);
		const noneAvailable = checkBookingNoneAvailable(original)
		return (
			<FormDropdown
				className="mr-2"
				disabled={allocated || noneAvailable}
				value={original.teacher ? original.teacher._id : ""}
				onChange={(evt) => onTeacherAllocationChanged(evt, original)}
			>
				<option> None </option>
				{teachers
					? teachers.map((teacher) => {
						return (
							<option value={teacher._id} key={teacher._id}>
								{teacher.first_name} {teacher.preferred_name && teacher.preferred_name !== teacher.first_name ? ' \'' + teacher.preferred_name.trim() + '\'' : null} {teacher.last_name}
							</option>
						);
					})
					: null}
			</FormDropdown>
		);
	};

	const filterFavorite = (fav_list, teachers) => {
		return teachers.filter((teacher) => {
			return fav_list.indexOf(teacher._id) > -1;
		});
	};

	const dateRangeCell = ({ original }) => {
		let {
			start_date_au,
			end_date_au,
			split_start_date,
			split_end_date,
			multiple_date,
			split_index,
			id,
			dates,
		} = original;
		let splits_length = numberOfSplitEvent
		let datesToSelect = [...dates]
		if (splits_length > 1) {
			datesToSelect = dates.slice(0, dates.length - numberOfSplitEvent + split_index + 1)
			datesToSelect = datesToSelect.filter(date => date?.date >= split_start_date)
		}
		if (multiple_date) {
			if (split_index === splits_length - 1 || splits_length === 0) {
				return (
					<>
						<p> From: {changeToAuDate(split_start_date)} </p>
						<p> To: {changeToAuDate(split_end_date)} </p>
					</>
				);
			} else {
				return (
					<>
						<p> From: {changeToAuDate(split_start_date)} </p>
						{/* <p> */} To:
						<FormDropdown
							onChange={(e) => onDateChange(e, id, split_index)}
						>
							{original.split_end_date ? (
								<option value={original.split_end_date} key={original.split_end_date} selected> {changeToAuDate(original.split_end_date)} </option>
							) : (
								<option value={datesToSelect[0].date} key={datesToSelect[0].date} selected> {changeToAuDate(datesToSelect[0].date)} </option>
							)}
							{/* <option> None </option> */}
							{datesToSelect
								? datesToSelect.map((date) => {
									return (
										<option value={date.date} key={date.date} selected={date.date === original.split_end_date}>
											{changeToAuDate(date.date)}
										</option>
									);
								})
								: null}
						</FormDropdown>
					</>
				);
			}
		} else {
			return <p> On: {start_date_au} </p>;
		}
	};

	const checkboxCell = ({
		value,
		original,
		columnProps: {
			rest: { func, label },
		},
	}) => {
		const flip = () => {
			if (func) {
				func(label, original.id);
			}
		};

		return <input type="checkbox" checked={value} onClick={flip} />;
	};

	const flipfilter = (label, id) => {
		let newData = data.map((item) => {
			if (item.id === id) {
				item[label] = !item[label];
				let teachers = [...allUsers];
				if (item.check_fav && item.fav_teacher_list)
					teachers = filterFavorite(item.fav_teacher_list, teachers);
				// if (item.check_ava)
				// if (item.check_25km)
				item.teachers = teachers;
			}
			return item;
		});
		setData(newData);
	};

	const changeToAuDate = (date) => {
		let dates = date.split("-");
		return `${dates[2]}/${dates[1]}/${dates[0]}`;
	};

	const onDateChange = (e, id, split_index) => {
		let splits_length = numberOfSplitEvent
		let end_date = e.target.value;
		if (split_index < splits_length - 1) {
			let newData = [...data];
			for (let i = 0; i < newData.length; i++) {
				let item = newData[i]
				if (item.id === id) {
					if (item.split_index === split_index) {
						item.split_end_date = end_date;
					}
					else if (item.split_index > split_index) {
						let newDates = item.all_dates.filter((date) => {
							return date.date > end_date;
						});
						// item.split_start_date = newDates[item.split_index - split_index]?.date
						item.split_start_date = newDates[item.split_index - split_index - 1]?.date
						item.split_end_date = newDates[item.split_index - split_index - 1]?.date
						if (item.split_index === numberOfSplitEvent - 1) {
							item.split_end_date = newDates[newDates.length - 1]?.date
						}
						else {
							item.split_end_date = newDates[item.split_index - split_index - 1]?.date
						}
					}
				}
				newData[i] = item
			};
			setData(newData);
		}
	};

	const hasAllocatedStatusForCurrentEvent = (original) => {
		const { id, split_index } = original;
		const oriBooking = data.find((el) => el.id === id);
		if (oriBooking) {
			if (oriBooking.multiple_date) {
				const event = data.find(
					(el) => el.id === id && el.split_index === split_index
				);
				if (event) {
					return event.status === teacherStatus.not_assigned || event.status === teacherStatus.none_available
						? false
						: event.teacher_response != teacherResponse.rejected;
				}
			} else {
				return !(oriBooking.status === teacherStatus.not_assigned || oriBooking.status === teacherStatus.none_available);
			}
		}
	};

	const hasCancelledByInst = (original) => {
		const { id, split_index } = original;
		
		const oriBooking = data.find((el) => el.id === id);
		if (oriBooking) {
		  if (oriBooking.multiple_date) {
			const event = data.find(
			  (el) => el.id === id && el.split_index === split_index
			);
			return event?.status === "cancelled by inst"
		  } else {
			return oriBooking.status === "cancelled by inst"
		  }
		}
	};

	const checkBookingNoneAvailable = (original) => {
		const { id, split_index } = original;
		
		const oriBooking = data.find((el) => el.id === id);
		if (oriBooking) {
		  if(oriBooking.isConfirm) return false
		  if (oriBooking.multiple_date) {
			const event = data.find(
			  (el) => el.id === id && el.split_index === split_index
			);
			if(event.isConfirm) return false
			else return event?.unavailable_teacher
		  } else {
			if(oriBooking.isConfirm) return false
			else return oriBooking?.unavailable_teacher
		  }
		}
	}

	const onTeacherAllocationChanged = (e, original) => {
		const { id, split_index } = original;
		let newData = [...data];
		const foundBooking = newData.find(
			(el) => el.id === id && el.split_index === split_index
		);
		if (foundBooking) {
			const teacher = allUsers.find((el) => el._id === e.target.value)
			if (original.institution_id == "6323f6c9ef66742353137bce" && teacher?.level === "senior") { // Wattle College
				notify.show('Cannot assign senior teacher for this institution.')
				return
			}
			foundBooking.teacher = teacher
			foundBooking.teachername = queryTeacherName(e.target.value);
			foundBooking.teacher_status = teacherStatus.assigned;
			foundBooking.teacher_response = teacherResponse.not_responded;
			foundBooking.teacher_cancel_reason = "";
		}
		setData(newData);
	};

	const buildEventSubmitButton = (props) => {
		const allocated = hasAllocatedStatusForCurrentEvent(props.original);
		const isConfirm = props.original.isConfirm;
		const cancelledByInst = hasCancelledByInst(props.original)
		return  !cancelledByInst ? ( 
		  isConfirm ? (
			!allocated ? (
			  <>
				<button
				  type="button"
				  className="btn btn-primary btn-sm"
				  onClick={() => onEventSubmitClicked(props)}
				>
				  Submit
				</button>
				<br />
				<button
				  type="button"
				  className="btn secondary-button-no-margin-hover btn-sm"
				  onClick={() => toggleConfirm(props, false)}
				>
				  Cancel
				</button>
			  </>
			) : (
			  <>
				<button
				  type="button"
				  className="btn btn-primary btn-sm"
				  onClick={() => onReassignClicked(props)}
				>
				  Clean assigned
				</button>
				<br />
				<button
				  type="button"
				  className="btn secondary-button-no-margin-hover btn-sm"
				  onClick={() => toggleConfirm(props, false)}
				>
				  Cancel
				</button>
			  </>
			)
		  ) : (
			<>
			  <button
				type="button"
				className="btn btn-primary btn-sm mb-2 d-block"
				onClick={() => toggleConfirm(props, true)}
			  >
				{allocated ? "Reassign" : "Assign"}
			  </button>
			  <button
				type="button"
				disabled={checkAvailability(props.original)}
				className={allocated ? "d-none" : "btn btn-primary btn-sm d-block"}
				onClick={() => confirmUnavailable(props)}
			  >
				None Available
			  </button>
			</>
		  )
		) : null
	};

	const getAmPmEve = (timeString) => {
		const timeArray = timeString.split(":");
		let hour = parseInt(timeArray[0]);
		return hour < 12 ? "AM" : hour < 15 ? "PM" : "EVE";
	  };

	const formateDate = (date) => {
		var d = new Date(date),
		  month = "" + (d.getMonth() + 1),
		  day = "" + d.getDate(),
		  year = d.getFullYear();
	
		if (month.length < 2) month = "0" + month;
		if (day.length < 2) day = "0" + day;
	
		return [year, month, day].join("-");
	  };

	const checkIfBookingIsSameDay = async (booking, teacher_id) => {

		const from = formateDate(booking.split_start_date)
		const to = formateDate(booking.split_end_date)
		const institution_id = booking.institution_id
		const selectedClass = booking.selected_class

		const res = await API.getBookingWithSameDateAndLevel(from, to, institution_id, teacher_id, selectedClass?._id, booking._id || booking.id)
		const result = res.data.data
	
		if (result.length > 0) {
		  // Check for conflicts on the same date and session
		  const conflictingBookings = []
		  
		  for (const booking of result) {
			// Skip if it's a different level
			// if (booking.class_level_id !== selectedLevel) {
			//   continue
			// }
	
			// Check if booking dates overlap
			const bookingStart = new Date(booking.booking_date)
			const bookingEnd = new Date(booking.end_booking_date)
			const newBookingStart = new Date(from)
			const newBookingEnd = new Date(to)
	
			// Check for date overlap
			if (bookingStart <= newBookingEnd && bookingEnd >= newBookingStart) {
			  // Check for session conflicts
			  const bookingSession = getAmPmEve(booking.start_time)
			  const newBookingSession = getAmPmEve(selectedClass.start_time)
			  
			  if (bookingSession === newBookingSession) {
				conflictingBookings.push({
					id: booking._id,
				  booking_date: booking.booking_date,
				  end_booking_date: booking.end_booking_date,
				  start_time: booking.start_time,
				  end_time: booking.end_time,
				  level: booking.level,
				  session: bookingSession
				})
			  }
			}
		  }

		  if (conflictingBookings.length > 0) {
			notify.show("There is a double booking for the same date and session.", "error");
			return true
		  }
		}
		return false
	  }

	const onEventSubmitClicked = async (props) => {
		const isDataValid = validateBookingInformation(props);
		if (isDataValid) {
			const { id, split_index, previous_teacher_allocation } = props.original;
			const foundBooking = data.find((el) => el.id === id);

			if (!foundBooking.multiple_date) {
				const event = data.find(
					(el) => el.id === id && el.split_index === split_index
				);
				const isDoubleBooking = await checkIfBookingIsSameDay(foundBooking, event.teacher._id);
				if (isDoubleBooking) {
					return;
				}
				assignTeacherForSingleBooking(
					id,
					split_index,
					event.teacher._id,
					previous_teacher_allocation
				);
			} else {
				const updatedInfo = prepareDataForSubmitting(props);
				if (updatedInfo) {
					const { booking_id, updated_splits, teacher_id, dates, updatedBooking } = updatedInfo;
					const isDoubleBooking = await checkIfBookingIsSameDay(foundBooking, teacher_id);
					if (isDoubleBooking) {
						return;
					}
					assignTeacherForMultipleDaysBooking(
						booking_id,
						updated_splits,
						teacher_id,
						split_index,
						dates,
						updatedBooking
					);
				}
			}
			toggleConfirm(props, false);
		}
	};

	const onReassignClicked = (props) => {
		const { id, split_index, teacher, multiple_date } = props.original;
		let newData = data.map((item) => {
			if (item.id === id && item.split_index === split_index) {
				item.teacher = null;
				item.teachername = "";
				item.status = teacherStatus.not_assigned;
				item.teacher_status = teacherStatus.not_assigned;
				item.teacher_response = teacherResponse.not_responded;
				item.previous_teacher_allocation = teacher._id;
				setCurrentSplitEventByBooking({
					...currentSplitEventByBooking,
					[item.id]: item.splits.length
				})
			}
			return item;
		});
		if (!multiple_date) {
			API.deallocateSingle(id);
		}

		if (multiple_date && split_index !== null && split_index !== undefined && +split_index >= 0) {
			API.deallocateSplit(id, split_index);
		}

		setData(newData);
		toggleConfirm(props, false);
	};

	const toggleConfirm = (props, isConfirm) => {
		const { id, split_index } = props.original;
		const newData = data.map((item) => {
			if (item.id === id && item.split_index === split_index) {
				item.isConfirm = isConfirm;
			}
			return item;
		});
		setData(newData);
	};

	const checkAvailability = (original) => {
		const { id, split_index } = original;
		const oriBooking = data.find((el) => el.id === id && el.split_index === split_index);
		if (oriBooking) {
			return oriBooking.unavailable_teacher || oriBooking.status === teacherStatus.none_available
		}
	};

	const confirmUnavailable = (props) => {
		const { id, split_index } = props.original;
		const foundBooking = data.find((el) => el.id === id);
		let newData = data.map((item) => {
			if (item.id === id && item.split_index === split_index) {
				// console.log(item)
				item.status = teacherStatus.none_available;
				item.teacher_status = teacherStatus.none_available;
				item.unavailable_teacher = true
			}
			return item;
		});
		if (!foundBooking.multiple_date) {
			API.markUnAvailableForBooking(id)
				.then(res => {
					notify.show("Set no availability to the booking.")
				})
				.catch(err => {
					console.log(err.response)
				})
		} else {
			const updatedInfo = prepareDataForConfirmingUnavailable(props);
			// console.log(updatedInfo)
			if (updatedInfo) {
				const { booking_id, updated_splits, dates } = updatedInfo;
				API.markUnAvailableForBooking(booking_id, updated_splits, dates, props.original.split_index)
					.then(res => {
						notify.show("Set no availability to the booking.")
					})
					.catch(err => {
						console.log(err.response)
					})
			}
		}
		setData(newData);
	}

	const validateBookingInformation = (props) => {
		let result = true;

		const { id, split_index } = props.original;
		const oriBooking = data.find((el) => el.id === id);
		const subEvent = data.find(
			(el) => el.id === id && el.split_index === split_index
		);
		if (oriBooking) {
			if (!subEvent.teacher) {
				result = false;
				notify.show("You must to assign a teacher before submitting.", "error");
			} else {
				if (currentSplitEventByBooking[id] > 1) {
					const allEvents = data.filter((el) => el.id === id);
					for (let i = 0; i < allEvents.length && result; i++) {
						const currentSplit = allEvents[i];
						const isFromValid = currentSplit.split_start_date != "error";

						if (!isFromValid) {
							result = false;
							notify.show("The split from date does not valid.", "error");
						} else {
							const isToValid = currentSplit.split_end_date != "error";

							if (!isToValid) {
								result = false;
								notify.show("The split to date does not valid.", "error");
							} else {
								if (
									currentSplit.split_start_date > currentSplit.split_end_date
								) {
									result = false;
									notify.show(
										"The current split' end date is before start date"
									);
								} else {
									for (let i = 0; i < allEvents.length && result; i++) {
										for (let j = i + 1; j < allEvents.length && result; j++) {
											const overlapped = validateSplitDateOverlap(
												allEvents[i],
												allEvents[j]
											);

											if (overlapped) {
												result = false;
												notify.show(
													"The split dates in the whole booking are not valid, there is an overlap among splits",
													"error"
												);
											}
										}
									}
								}
							}
						}
					}
				}
			}
		} else {
			result = false;
			notify.show("Cannot find booking info for the current id", "error");
		}

		return result;
	};

	const assignTeacherForSingleBooking = (
		booking_id,
		split_index,
		teacher_id,
		previous_teacher_id
	) => {
		try {
			API.assignTeacherToBooking("/assignTeacherToBooking", {
				teacher_id: teacher_id,
				booking_id: booking_id,
				previous_teacher_allocation: previous_teacher_id,
			})
				.then(function (result) {
					notify.show("Sucessfully assigned a teacher.");
					updateTeacherAssignedStatus(booking_id, split_index);
				})
				.catch(function (err) {
					notify.show("Failed to assign a teacher.", "error");
				});
		} catch (error) {
			notify.show(error, "error");
		}
	};

	const assignTeacherForMultipleDaysBooking = (
		booking_id,
		updated_splits,
		teacher_id,
		split_index,
		dates,
		updatedBooking
	) => {
		try {
			API.assignTeacherToBooking("/assignTeacherToMultipleDayBooking", {
				updated_splits: updated_splits,
				teacher_id: teacher_id,
				booking_id: booking_id,
				dates: dates,
				updated_booking: updatedBooking
			}).then(function (result) {
				notify.show("Sucessfully assigned a teacher.");
				updateTeacherAssignedStatus(booking_id, split_index);
			})
				.catch(function (err) {
					notify.show("Failed to assign a teacher.", "error");
				});

		} catch (error) {
			notify.show(error, "error");
		}
	};

	const prepareDataForSubmitting = (props) => {
		const { id, split_index, all_dates, previous_teacher_allocation } =
		  props.original;
		const foundBooking = data.find(
		  (el) => el.id === id && el.split_index === split_index
		);
		let updatedBooking = null;
		if (foundBooking) {
		  // Query teacher id from current event
	
		  // Get all event information of current booking
		  const splits = [];
		  let newDates = [];
		  const events = data.filter((el) => el.id === id);
		  if (events) {
			events.forEach((event, index) => {
			  const info = {
				date_from: event.split_start_date || "",
				date_to: event.split_end_date || "",
				teacher_id: event.teacher ? event.teacher._id : null,
				teacher_response:
				  index === split_index
					? teacherResponse.not_responded
					: event.teacher_response || teacherResponse.not_responded,
				teacher_status:
				  index === split_index
					? teacherStatus.assigned
					: event.teacher_status || teacherStatus.not_assigned,
				payment_status: event.payment_status || "",
				previous_teacher_allocation: previous_teacher_allocation,
			  };
			  if (event.status === "cancelled by inst") {
				// console.log(event)
				info.cancelled_by_inst = true;
				info.cancelled_by = event.cancelled_by;
				info.cancelled_time = event.cancelled_time;
				info.inst_cancelled_reason = event.inst_cancel_reason;
			  }
			  splits.push(info);
			  if(index === split_index) {
				updatedBooking = info
			  }
			});
	
			newDates = all_dates.map((dateObj) => {
			  if (
				dateObj.date >= foundBooking.split_start_date &&
				dateObj.date <= foundBooking.split_end_date
			  ) {
				dateObj.teacher_id = foundBooking.teacher._id;
				dateObj.teacher_status = teacherStatus.assigned;
				dateObj.teacher_response = teacherResponse.not_responded;
				dateObj.previous_teacher_allocation = previous_teacher_allocation;
				dateObj.unavailable_teacher = false;

				if(!dateObj.cancelled_by_inst) {
				  delete dateObj.cancelled_time
				  delete dateObj.teacher_cancel_reason
				}
				delete dateObj.is_rdo
			  }
			  return dateObj;
			});
		  }
	
		  return {
			booking_id: id,
			updated_splits: splits,
			teacher_id: foundBooking.teacher._id,
			dates: newDates,
			updatedBooking
		  };
		} else {
		  return null;
		}
	};

	const prepareDataForConfirmingUnavailable = (props) => {
		const { id, split_index, all_dates, previous_teacher_allocation } =
			props.original;
		const foundBooking = data.find(
			(el) => el.id === id && el.split_index === split_index
		);
		if (foundBooking) {
			const splits = [];
			let newDates = [];
			const events = data.filter((el) => el.id === id);
			if (events) {
				events.forEach((event, index) => {
					// console.log(event)
					const info = {
						date_from: event.split_start_date || "",
						date_to: event.split_end_date || "",
						teacher_id: event.teacher ? event.teacher._id : null,
						teacher_response:
							index === split_index
								? teacherResponse.not_responded
								: event.teacher_response || teacherResponse.not_responded,
						teacher_status:
							index === split_index
								? teacherStatus.none_available
								: event.teacher_status || teacherStatus.not_assigned,
						payment_status: event.payment_status || "",
						previous_teacher_allocation: previous_teacher_allocation,
						unavailable_teacher: index === split_index ? true : event.unavailable_teacher || false
					};
					splits.push(info);
				});

				newDates = all_dates.map((dateObj) => {
					if (
						dateObj.date >= foundBooking.split_start_date &&
						dateObj.date <= foundBooking.split_end_date
					) {
						dateObj.teacher_id = foundBooking.teacher_id ? foundBooking.teacher_id : null;
						dateObj.teacher_status = teacherStatus.none_available
						dateObj.teacher_response = teacherResponse.not_responded;
						dateObj.previous_teacher_allocation = previous_teacher_allocation;
						dateObj.unavailable_teacher = true
					}
					return dateObj;
				});
			}

			return {
				booking_id: id,
				updated_splits: splits,
				dates: newDates,
			};
		} else {
			return null;
		}
	};

	const validateSplitDateOverlap = (split1, split2) => {
		let split1FromTime = new Date(split1.split_start_date).getTime();
		let split1ToTime = new Date(split1.split_end_date).getTime();

		if (split1FromTime > split1ToTime) {
			return true;
		}

		let split2FromTime = new Date(split2.split_start_date).getTime();
		let split2ToTime = new Date(split2.split_end_date).getTime();

		if (split2FromTime > split2ToTime) {
			return true;
		}

		return (
			Math.max(split1FromTime, split2FromTime) <=
			Math.min(split1ToTime, split2ToTime)
		);
	};

	const updateTeacherAssignedStatus = (id, split_index) => {
		const newData = [...data];
		const oriBooking = newData.find((el) => el.id === id);
		const foundEvent = newData.find(
			(el) => el.id === id && el.split_index === split_index
		);

		if (foundEvent) {
			updateLastAllocation(oriBooking, split_index, foundEvent.teacher._id);

			foundEvent.status = teacherStatus.assigned;
			foundEvent.teacher_status = teacherStatus.assigned;
			foundEvent.teacher_response = teacherResponse.not_responded;
			foundEvent.payment_status = "";
		}

		let currentTime = new Date(oriBooking.end_date).getTime();
		const tobeUpdatedBookings = newData.filter((el) => {
			let comparedTime = new Date(el.end_date).getTime();
			return comparedTime > currentTime;
		});
		tobeUpdatedBookings.forEach(
			(booking) =>
			(booking.last_allocate = getLastBookingTeacherAllocation(
				booking.campus_id,
				booking.end_date
			))
		);

		setData(newData);
	};

	const updateLastAllocation = (oriBooking, split_index, newTeacherId) => {
		try {
			const instId = queryInstitutionId(oriBooking.campus_id);
			const bookingList = bookingDict[instId] || null;
			if (bookingList) {
				const booking = bookingList.find((el) => el._id === oriBooking.id);
				if (oriBooking.multiple_date) {
					if (split_index < booking.splits.length) {
						booking.splits[split_index].teacher_id = newTeacherId;
					} else {
						const newEventCount = split_index - booking.splits.length;
						for (let i = 0; i < newEventCount; i++) {
							booking.splits.push({ teacher_id: null });
						}
						if (booking.splits.length > 0) {
							booking.splits[0].teacher_id = newTeacherId;
						}
					}
				} else {
					booking.teacher_id = newTeacherId;
				}
			}
		} catch (error) {
			console.log("FOUND ERR on updateLastAllocation: ", error)
		}
	};

	const handleTestBookingsDisplayChanges = () => {
		setShowTestBookings(!showTestBookings)
	}

	const bookingColumns = useMemo(() => [
		// {
		// 	Header: "ID",
		// 	accessor: "id",
		// 	width: 75,
		// 	Cell: (props) => {
		// 	  return props.original.id
		// 	},
		// 	filterable: false,
		// },
		{
			Header: "Created",
			accessor: "created",
			Cell: (props) => 
				!props.original.is_subjob &&
				!!props.original.created && (
					<Moment
						tz="Australia/Melbourne"
						parse="YYYY-MM-DD HH:mm:ss"
						format="DD/MM/YYYY">
						{moment.utc(props.original.created)}
					</Moment>
				),
			filterable: false
		},
		{
			Header: "Created Time",
			accessor: "created_time",
			width: 75,
			show: showCreatedTime,
			Cell: (props) =>
				!props.original.is_subjob &&
				!!props.original.created && (
					<Moment
						tz="Australia/Melbourne"
						parse="YYYY-MM-DD HH:mm:ss"
						format="HH:mm:ss"
					>
						{moment.utc(props.original.created)}
					</Moment>
				),
		},
		{
			Header: "From",
			accessor: "start_date",
			Cell: (props) =>
				!props.original.is_subjob && props.original.start_date_au,
			defaultSortDesc: true,
			filterable: false,
		},
		{
			Header: "End",
			accessor: "end_date",
			Cell: (props) =>
				!props.original.is_subjob &&
				props.original.end_date_au,
			defaultSortDesc: false,
			filterable: false,
		},
		{
			Header: "Arrival ",
			accessor: "arrival",
			width: 75,
			show: showArrival,
			Cell: (props) =>
				!props.original.is_subjob && props.original.arrival,
			filterable: false,
		},
		{
			Header: "Start",
			accessor: "start",
			width: 75,
			Cell: (props) =>
				!props.original.is_subjob && props.original.start,
			filterable: false,
		},
		{
			Header: "End",
			accessor: "end",
			width: 75,
			Cell: (props) =>
				!props.original.is_subjob && props.original.end,
			filterable: false,
		},
		{
			Header: "Days",
			accessor: "days_of_delivery",
			width: 75,
			Cell: (props) => {
				return props.original.is_subjob
					? ""
					: props.original.days_of_delivery
						?.map((day) => day.substr(0, 2))
						?.join(", ")
			},
			filterable: false,
		},
		{
			Header: "Level/Type",
			accessor: "level",
			width: 120,
			Cell: (props) =>
				!props.original.is_subjob && props.original.level,
			filterable: false,
		},
		{
			Header: "Update Level",
			width: 140,
			show: showUpdateLevel,
			Cell: (props) => !props.original.is_subjob && buildUpdateLevel(props)
		},
		{
			Header: "Class tag",
			accessor: "reference_name",
			Cell: (props) => {
				return props.original?.classRef
			},
			filterable: false,
			width: 90,
		},
		{
			Header: "Mode",
			accessor: "deliveryMode",
			width: 90,
			Cell: (props) =>
				!props.original.is_subjob && props.original.deliveryMode,
			filterable: false
		},
		{
			Header: "Inst.",
			accessor: "institution",
			width: 120,
			Cell: (props) =>
				!props.original.is_subjob && props.original.institution,
			filterable: false
		},
		{
			Header: "Campus",
			accessor: "campus_city",
			show: showCampus,
			width: 100,
			Cell: (props) =>
				!props.original.is_subjob && props.original.campus_city,
			filterable: false
		},
		{
			Header: "Maker",
			accessor: "makername",
			width: 90,
			Cell: (props) =>
				!props.original.is_subjob && props.original.makername,
			filterable: false
		},
		{
			Header: "T hrs/day",
			accessor: "teaching_hour",
			show: showTeachingHours,
			Cell: (props) =>
				!props.original.is_subjob && props.original.teaching_hour,
			filterable: false,
			width: 60,
		},
		{
			Header: "Total T hrs",
			accessor: "total_teaching_hour",
			Cell: (props) =>
				!props.original.is_subjob && props.original.total_teaching_hour,
			filterable: false,
			width: 60
		},
		{
			Header: "NT",
			accessor: "non_teaching_mins",
			show: showNonTeachingHours,
			Cell: (props) =>
				!props.original.is_subjob &&
				props.original.non_teaching_mins,
			filterable: false,
			width: 60,
		},
		{
			Header: "Last T",
			accessor: "last_allocate",
			show: showLastTeacher,
			minWidth: 90,
			Cell: (props) =>
				!props.original.is_subjob && props.original.last_allocate,
			filterable: false
		},
		{
			Header: "Preferred T",
			accessor: "pref_tea_name",
			width: 90,
			filterable: false
		},
		{
			Header: "No. of Events (Lessons)",
			accessor: "lessons",
			style: { whiteSpace: "unset" },
			width: 60,
			Cell: (props) =>
				!props.original.is_subjob && props.original.lessons,
			filterable: false
		},
		{
			Header: "Split Booking",
			Cell: (props) => buildSplitCheckboxes(props),
			width: 90,
		},
		{
			Header: "Split dates selection",
			Cell: (props) => dateRangeCell(props),
			width: 150,
		},
		{
			Header: "FAV",
			accessor: "check_fav",
			show: showFav,
			width: 60,
			Cell: (props) => checkboxCell(props),
			getProps: () => ({
				func: flipfilter,
				label: "check_fav",
			}),
		},
		{
			Header: "Teachers",
			width: 135,
			Cell: (props) => dropdownCell(props),
		},
		{
			Header: "Available",
			accessor: "check_ava",
			width: 60,
			show: showAvail,
			Cell: (props) => checkboxCell(props),
			getProps: () => ({
				func: flipfilter,
				label: "check_ava",
			}),
		},
		{
			Header: "25kms",
			accessor: "check_25km",
			width: 60,
			show: show25kms,
			Cell: (props) => checkboxCell(props),
			getProps: () => ({
				func: flipfilter,
				label: "check_25km",
			}),
		},
		{
			Header: "Allocation",
			accessor: "teachername",
			width: 120,
			filterable: false,
		},
		{
			Header: "Submit",
			width: 110,
			Cell: (props) => buildEventSubmitButton(props),
		},
		{
			Header: "Status",
			accessor: "status",
			filterable: false
		},
		{
			Header: "Reason for Cancellation",
			accessor: "teacher_cancel_reason",
			// width: 200,
			Cell: (props) => {
				if (props.original.teacher_cancel_reason) {
					let reason =
						cancellationReasons.find(
							(r) =>
								r.value === props.original.teacher_cancel_reason
						) || {};
					return reason.description;
				} else if (props.original.inst_cancel_reason) {
					return props.original.inst_cancel_reason
				}
			},
			filterable: false,
			width: 200,
		},
		{
			Header: "Canceled Time",
			accessor: "cancelled_time",
			Cell: (props) => {
				return props.original.cancelled_time ? <Moment tz="Australia/Melbourne" parse="YYYY-MM-DD HH:mm:ss" format="DD/MM/YYYY HH:mm:ss">
					{moment.utc(props.original.cancelled_time)}
				</Moment> : null
			},
			filterable: false,
			width: 200,
		},
		{
			Header: "Canceled By",
			accessor: "cancelled_by",
			Cell: (props) => {
				return props.original.cancelled_by
			},
			filterable: false,
			width: 200,
		},
		{
			Header: "Last Status",
			accessor: "last_status_before_cancel",
			Cell: (props) => {
				return props.original.last_status_before_cancel
			},
			filterable: false,
			width: 200,
		}
	]);

	let initialFilter = {
		createdDate: null,
		startDate: null,
		endDate: null,
		arrivalTime: null,
		startTime: null,
		endTime: null,
		days: null,
		levelType: null,
		mode: null,
		inst: null,
		maker: null,
		totalTeachingHours: null,
		preferredTeacher: null,
		numberOfEvents: null,
		allocation: null,
		status: null,
		cancelReason: null,
		bookingType: null,
		level: null
	}
	const [filter, setFilter] = useState(initialFilter)
	const [sorting, setSorting] = useState({
		sort_by: "status",
		sort_type: '-1'
	})
	

	const submitFilter = async (filter, sorting, page = 1, limit = 20) => {
		setAllBookinngsLoaded(false);
		// console.log("filter: ", filter)
		setFilter(filter)
		setSorting(sorting)
		// console.log("Filter applied: ", filter)
		const filterReq = {
			page, // always reset to page 1 when filter
			limit,
			["filter[start_date]"]: filter.startDate ? moment(filter.startDate).format("YYYY-MM-DD") : null,
			["filter[end_date]"]: filter.endDate ? moment(filter.endDate).format("YYYY-MM-DD") : null,
			["filter[institution_ids]"]: filter.inst,
			["filter[campuses]"]: filter.campus,
			["filter[booking_maker_ids]"]: filter.maker,
			["filter[allocations]"]: filter.allocation,
			["filter[status]"]: filter.status,
			["filter[cancel_reason]"]: filter.cancelReason,
			["filter[booking_type]"]: filter.bookingType,
			["filter[level]"]: filter.level,
			["filter[preferred_teacher]"]: filter.preferredTeacher,
			sort_by: sorting.sort_by.toUpperCase(),
			sort_type: sorting.sort_type
		}
		const result = await API.getListBooking(filterReq)
		// console.log(result.data)
		setPaginate(result.data?.paginate)
		groupBookingsBasedOnId(result.data.bookings);
		convertBookings(result.data.bookings);
	};

	const onChangePage = async (page, limit = 20) => {
		// console.log("filter: ", filter)
		const filterReq = {
			page, // always reset to page 1 when filter
			limit,
			["filter[start_date]"]: filter.startDate ? moment(filter.startDate).format("YYYY-MM-DD") : null,
			["filter[end_date]"]: filter.endDate ? moment(filter.endDate).format("YYYY-MM-DD") : null,
			["filter[institution_ids]"]: filter.inst,
			["filter[campuses]"]: filter.campus,
			["filter[booking_maker_ids]"]: filter.maker,
			["filter[allocations]"]: filter.allocation,
			["filter[status]"]: filter.status,
			["filter[cancel_reason]"]: filter.cancelReason,
			["filter[booking_type]"]: filter.bookingType,
			["filter[level]"]: filter.level,
			["filter[preferred_teacher]"]: filter.preferredTeacher,
			sort_by: sorting.sort_by.toUpperCase(),
			sort_type: sorting.sort_type
		}
		setAllBookinngsLoaded(false);
		const result = await API.getListBooking(filterReq)
		setPaginate(result.data?.paginate)
		groupBookingsBasedOnId(result.data.bookings);
		convertBookings(result.data.bookings);
		setAllBookinngsLoaded(true);
	}

	return (
		allCampus && allInst && allUsers && allInstUsers && allClass &&
		<AdminWrapper>
			<SwitchMenuBar isViewAsTeacher />
			<div className="body-main-page-JobList">
				<div className="d-flex justify-center my-2">
					<p className="text-3xl font-bold flex flex-col justify-center ml-10">
						ALL BOOKINGS
					</p>
				</div>

				<div className="d-flex justify-center my-2">
					<BuildFilterBooking 
						initialFilter={initialFilter} 
						submitFilter={submitFilter} 
						institutions={allInst.filter(inst => !inst.archived)} 
						teachers={allUsers} 
						campuses={allCampus}
						customers={allInstUsers}
						disabled={!isAllBookinngsLoaded}
					/>
				</div>

				<div className="d-flex flex-row overflow-auto collapse-check-buttons justify-between">
					<CheckableButton
						noBorder
						checked={showCreatedTime}
						onClick={() => setShowCreatedTime((s) => !s)}
						onChange={(e) => setShowCreatedTime(e.target.checked)}
					>
						Created Time
					</CheckableButton>
					<CheckableButton
						noBorder
						checked={showArrival}
						onClick={() => setShowArrival((s) => !s)}
						onChange={(e) => setShowArrival(e.target.checked)}
					>
						Arrival
					</CheckableButton>
					<CheckableButton
						noBorder
						checked={showUpdateLevel}
						onClick={() => setShowUpdateLevel((s) => !s)}
						onChange={(e) => setShowUpdateLevel(e.target.checked)}
					>
						Update Level
					</CheckableButton>
					<CheckableButton
						noBorder
						checked={showCampus}
						onClick={() => setShowCampus((s) => !s)}
						onChange={(e) => setShowCampus(e.target.checked)}
					>
						Campus
					</CheckableButton>
					<CheckableButton
						noBorder
						checked={showTeachingHours}
						onClick={() => setShowTeachingHours((s) => !s)}
						onChange={(e) => setShowTeachingHours(e.target.checked)}
					>
						T hrs/day
					</CheckableButton>
					<CheckableButton
						noBorder
						checked={showNonTeachingHours}
						onClick={() => setShowNonTeachingHours((s) => !s)}
						onChange={(e) => setShowNonTeachingHours(e.target.checked)}
					>
						NT
					</CheckableButton>
					<CheckableButton
						noBorder
						checked={showLastTeacher}
						onClick={() => setShowLastTeacher((s) => !s)}
						onChange={(e) => setShowLastTeacher(e.target.checked)}
					>
						Last Teacher
					</CheckableButton>
					<CheckableButton
						noBorder
						checked={showFav}
						onClick={() => setShowFav((s) => !s)}
						onChange={(e) => setShowFav(e.target.checked)}
					>
						Show Fav
					</CheckableButton>
					<CheckableButton
						noBorder
						checked={showAvail}
						onClick={() => setShowAvail((s) => !s)}
						onChange={(e) => setShowAvail(e.target.checked)}
					>
						Show Avail
					</CheckableButton>
					<CheckableButton
						noBorder
						checked={show25kms}
						onClick={() => setShow25kms((s) => !s)}
						onChange={(e) => setShow25kms(e.target.checked)}
					>
						Show 25kms
					</CheckableButton>
					<CheckableButton
						noBorder
						checked={showTestBookings}
						onClick={() => {
							setShowTestBookings((s) => !s);
							handleTestBookingsDisplayChanges()
						}
						}
					// onChange={handleTestBookingsDisplayChanges}
					>
						Show Test Bookings
					</CheckableButton>
				</div>
				<ReactTable
					className="-striped -highlight my-3"
					showPagination={false}
					data={showTestBookings ? data : data.filter(job => job.makername !== "ReadyTeacher T." && job.institution !== "ReadyTeacherTest")}
					sortable={false}
					loading={!isAllBookinngsLoaded}
					pageSize={data.length}
					columns={bookingColumns}
				/>
				<div className="d-flex justify-content-center">
					<Pagination
						className="mt-3 mr-5"
						page={paginate.page}
						count={paginate.total_page}
						onChange={(e, value) => {
							onChangePage(value)
						}}
					/>
					{/* <FormDropdown
						value={paginate.limit}
						onChange={(e) => {
							onChangePage(value)
						}}
					>
						<option value={5}>5 rows</option>
						<option value={10}>10 rows</option>
						<option value={20}>20 rows</option>
						<option value={50}>50 rows</option>
						<option value={100}>100 rows</option>
					</FormDropdown> */}
					</div>
			</div>
		</AdminWrapper>
	)
}

const mapStateToProps = (state) => {
	return {
	  simpleQualifications: state.user?.simpleQualifications || []
	}
}
  
export default connect(mapStateToProps)(AllocationTableNewPage);